webpackJsonp([69643578646065],{

/***/ 1408:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CreateStockTransferTemplateItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"productId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"requestedQuantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-create-stock-transfer-template-item-input-8090cefe7341fe41d940.js